export default __webpack_public_path__ + "static/media/trackSmall.c2729cb4.png";